{
  "m0_1": {
    "ageLabel": "0–1 месяц",
    "tiredSigns": "Отводит взгляд, зевает, сжимает кулачки, вдруг замер",
    "phases": [
      {
        "title": "Кормление",
        "tip": "Долго и спокойно, с перерывом столбиком"
      },
      {
        "title": "Столбиком, подгузник",
        "tip": "5–10 мин вертикально, потом подгузник"
      },
      {
        "title": "Общение",
        "tip": "Лицо близко, тихий голос, чуть-чуть на животик"
      },
      {
        "title": "Успокоение",
        "tip": "Пеленание, на руки, приглушить свет"
      },
      {
        "title": "Укладывание",
        "tip": "Шум, ш-ш-ш, покачивание — до сонливости"
      }
    ]
  },
  "m1_2": {
    "ageLabel": "1–2 месяца",
    "tiredSigns": "Взгляд в сторону, зевок, трёт лицо, капризит без причины",
    "phases": [
      {
        "title": "Кормление",
        "tip": "Сразу после сна, отдельно от засыпания"
      },
      {
        "title": "Столбиком, подгузник",
        "tip": "Животик отдыхает, можно поговорить"
      },
      {
        "title": "Игра",
        "tip": "Животик 1–3 мин, следить за игрушкой, первые улыбки"
      },
      {
        "title": "Спокойно",
        "tip": "Носить, показывать окно, тихий голос"
      },
      {
        "title": "Ритуал и сон",
        "tip": "Свет тише, пеленание, шум, на руки"
      }
    ]
  },
  "m2_3": {
    "ageLabel": "2–3 месяца",
    "tiredSigns": "Взгляд в сторону, зевок, трёт лицо — сразу укладывать",
    "phases": [
      {
        "title": "Кормление",
        "tip": "Сразу после сна, отдельно от засыпания"
      },
      {
        "title": "Столбиком, подгузник",
        "tip": "Животик отдыхает, поговорить, показать комнату"
      },
      {
        "title": "Активная игра",
        "tip": "Животик 2–5 мин, гимнастика и массаж, следить за игрушкой, коврик"
      },
      {
        "title": "Спокойно",
        "tip": "Носить по квартире, окно, тихий разговор, потрогать ткани"
      },
      {
        "title": "Ритуал и сон",
        "tip": "Свет тише, мешок, белый шум, на руки, соска до «окна»"
      }
    ]
  },
  "m3_4": {
    "ageLabel": "3–4 месяца",
    "tiredSigns": "Зевок, трёт глаза, тянет уши, «зависает» взглядом",
    "phases": [
      {
        "title": "Кормление",
        "tip": "Ест быстрее и отвлекается — тихое место"
      },
      {
        "title": "Столбиком, подгузник",
        "tip": "Коротко, он уже рвётся играть"
      },
      {
        "title": "Активная игра",
        "tip": "Животик до 10 мин, хватает игрушки, перевороты, погремушка в руке"
      },
      {
        "title": "Смена обстановки",
        "tip": "Другая комната, шезлонг, прогулка, окно"
      },
      {
        "title": "Спокойно",
        "tip": "Книжка с картинками, на руках, тихая песня"
      },
      {
        "title": "Ритуал и сон",
        "tip": "Темно, мешок, шум, одинаковая фраза перед сном"
      }
    ]
  },
  "m4_6": {
    "ageLabel": "4–6 месяцев",
    "tiredSigns": "Трёт глаза и уши, зевает, хнычет, отворачивается от игрушек",
    "phases": [
      {
        "title": "Кормление",
        "tip": "После сна; с 6 мес — первый прикорм в дневное окно"
      },
      {
        "title": "Уход",
        "tip": "Подгузник, умыть, переодеть"
      },
      {
        "title": "Активная игра",
        "tip": "Пол, перевороты, тянется к игрушкам, ку-ку, зеркало"
      },
      {
        "title": "Прогулка или новое место",
        "tip": "Коляска, слинг, другая комната, стульчик рядом с вами"
      },
      {
        "title": "Спокойно",
        "tip": "Книжка, мягкие игрушки, потрогать разное, на руках"
      },
      {
        "title": "Ритуал и сон",
        "tip": "Тот же порядок каждый раз: темно, мешок, шум, фраза"
      }
    ]
  },
  "m6_9": {
    "ageLabel": "6–9 месяцев",
    "tiredSigns": "Трёт глаза, зевает, ложится головой на пол, цепляется за вас",
    "phases": [
      {
        "title": "Еда",
        "tip": "Молоко после сна, прикорм — во втором окне дня"
      },
      {
        "title": "Уход",
        "tip": "Подгузник, лицо и руки после еды"
      },
      {
        "title": "Активная игра",
        "tip": "Сидит, ползёт, кубики, стучать, бросать, пальчиковая еда"
      },
      {
        "title": "Прогулка",
        "tip": "Свежий воздух, новые лица и звуки"
      },
      {
        "title": "Спокойно",
        "tip": "Книжки, тихая игра на полу рядом, песенки"
      },
      {
        "title": "Ритуал и сон",
        "tip": "Затемнение, мешок, шум, короткая книжка или песня"
      }
    ]
  },
  "m9_12": {
    "ageLabel": "9–12 месяцев",
    "tiredSigns": "Трёт глаза, зевает, капризит, становится неуклюжим",
    "phases": [
      {
        "title": "Еда",
        "tip": "Полноценный приём пищи за столом, молоко после"
      },
      {
        "title": "Уход",
        "tip": "Умыть, подгузник, переодеть"
      },
      {
        "title": "Активная игра",
        "tip": "Ползает, встаёт у опоры, сортеры, пирамидка, прятки"
      },
      {
        "title": "Прогулка",
        "tip": "Площадка, песок, трава — трогать и исследовать"
      },
      {
        "title": "Перекус",
        "tip": "Фрукт, вода, немного молока"
      },
      {
        "title": "Спокойно",
        "tip": "Книжки, тихие игрушки, приглушить свет за полчаса"
      },
      {
        "title": "Ритуал и сон",
        "tip": "Тот же ритуал; может протестовать — это возраст"
      }
    ]
  },
  "m12_18": {
    "ageLabel": "12–18 месяцев",
    "tiredSigns": "Трёт глаза, зевает, истерики на пустом месте, просится на руки",
    "phases": [
      {
        "title": "Еда",
        "tip": "За столом со всеми, сам ложкой"
      },
      {
        "title": "Уход",
        "tip": "Умыть, подгузник, одеться на улицу"
      },
      {
        "title": "Прогулка",
        "tip": "Ходить, лазать, песочница — тратить энергию"
      },
      {
        "title": "Перекус",
        "tip": "Фрукт, хлеб, вода"
      },
      {
        "title": "Игра дома",
        "tip": "Кубики, машинки, рисование, «помогать» по дому"
      },
      {
        "title": "Спокойно",
        "tip": "Книжки, пазлы, свет тише, без экранов"
      },
      {
        "title": "Ритуал и сон",
        "tip": "Купание, книжка, темно, одинаковая фраза"
      }
    ]
  },
  "m2_3_gas": {
    "ageLabel": "2–3 месяца · при газиках",
    "tiredSigns": "Зевок, взгляд в сторону, трёт лицо — сразу «Дальше»",
    "phases": [
      {
        "title": "Подгузник + массаж",
        "tip": "На пустой живот: по часовой, «велосипед», коленки к животу"
      },
      {
        "title": "Кормление",
        "tip": "Спокойно, с паузой на столбик в середине"
      },
      {
        "title": "Лёгкая игра",
        "tip": "На руках у окна, погремушка, поговорить. Зевнул — дальше"
      },
      {
        "title": "Столбиком, спокойно",
        "tip": "Свет тише, носить вертикально, ш-ш-ш — воздух выходит"
      },
      {
        "title": "Ритуал и сон",
        "tip": "Мешок, белый шум, на бочок с рукой, потом на спину"
      }
    ]
  }
}
